import request from "../../utils/request";

export function doGetAllRoutePlans(params) {
  return request("/route-plans", {
    method: "GET",
    params,
  });
}

export function doCreateRoutePlan(params) {
  return request("/route-plans", {
    method: "POST",
    data: params,
  });
}

export function doUpdateRoutePlan(params) {
  return request(`/route-plans/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDetailRoutePlan(id) {
  return request(`/route-plans/${id}`, {
    method: "GET",
  });
}

export function doDuplicateRoutePlan(params) {
  return request(`/route-plans/${params.id}/duplicate`, {
    method: "POST",
    data: params,
  });
}

export function doGetTokenRoutePlanLabel(params) {
  return request(`/route-plans/${params.id}/get-token-download-label`, {
    method: "GET",
  });
}

export function doOptimizeDuplicateRoutePlan(params) {
  const { id, cloneRoute } = params;
  return request(`/route-plans/${id}/${cloneRoute}`, {
    method: "POST",
  });
}

export function doDeleteRoutePlan(id) {
  return request(`/route-plans/${id}`, {
    method: "DELETE",
  });
}

export function doAddOrdersRoutePlan(params) {
  return request(`/route-plans/${params.id}/add-orders`, {
    method: "POST",
    data: params,
  });
}

export function doRemoveOrdersRoutePlan(params) {
  return request(`/route-plans/${params.id}/remove-orders`, {
    method: "POST",
    data: params,
  });
}

export function doAddDriversRoutePlan(params) {
  return request(`/route-plans/${params.id}/add-drivers`, {
    method: "POST",
    data: params,
  });
}

export function doRemoveDriversRoutePlan(params) {
  return request(`/route-plans/${params.id}/remove-drivers`, {
    method: "POST",
    data: params,
  });
}

export function doOptimizeRoutePlan(params) {
  return request(`/route-plans/${params.id}/optimize`, {
    method: "POST",
    data: params,
  });
}

export function doUpdateAndOptimizeRoutePlan(params) {
  return request(`/route-plans/${params.id}/update-and-optimize`, {
    method: "POST",
    data: params,
  });
}

export function doReorderRoute(params) {
  return request(`/route-plans/${params.id}/reorder-orders`, {
    method: "POST",
    data: params,
  });
}

export function doDispatchRoutePlan(params) {
  return request(`/route-plans/${params.id}/dispatch-drivers`, {
    method: "POST",
    data: params,
  });
}

export function doLockDriver(params) {
  return request(`/route-plans/${params.id}/lock-driver`, {
    method: "POST",
    data: params,
  });
}

export function doEditDriver(params) {
  return request(`/route-plans/${params.id}/edit-driver`, {
    method: "POST",
    data: params,
  });
}

export function doSwapOrdersToDriver(params) {
  return request(`/route-plans/${params.id}/swap-orders-to-driver`, {
    method: "POST",
    data: params,
  });
}

export function doUpdateIsLive(params) {
  return request(`/route-plans/${params.id}/is-live`, {
    method: "PUT",
    data: params,
  });
}
